<h3>Seção de Coleção</h3>
<form
  class="form-b4a"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px"
>
  <span class="p-float-label two-columns">
    <p-autoComplete
      [suggestions]="categories"
      formControlName="name"
      filterBy="name,slug"
      optionLabel="name"
      optionValue="id"
      appendTo="body"
      [lazy]="false"
      [multiple]="false"
      (completeMethod)="searchCollections($event)"
      placeholder="Busque pelo nome ou slug"
      name="name"
      inputId="name"
      (onSelect)="collectionChanged($event)"
    >
      <ng-template pTemplate="item" let-item>
        {{ item.name }} [{{ item.slug }}] [{{ item.shops.join(',') }}]
      </ng-template>
    </p-autoComplete>
    <label for="name">Coleção</label>
  </span>

  <span class="p-float-label">
    <input
      type="text"
      readonly
      pInputText
      formControlName="slug"
      id="slug"
      name="slug"
    />
    <label for="slug">Slug *</label>
  </span>

  <span class="p-float-label">
    <input
      type="text"
      readonly
      pInputText
      formControlName="title"
      id="title"
      name="title"
    />
    <label for="title">Título *</label>
  </span>

  <span class="p-float-label">
    <p-calendar
      inputId="publishDate"
      dateFormat="dd/mm/yy"
      appendTo="body"
      formControlName="publishDate"
      [showTime]="true"
      [hourFormat]="24"
    />
    <label for="publishDate">Data de Publicação</label>
  </span>

  <span class="p-float-label">
    <p-calendar
      inputId="expirationDate"
      dateFormat="dd/mm/yy"
      appendTo="body"
      formControlName="expirationDate"
      [showTime]="true"
      [hourFormat]="24"
    />
    <label for="expirationDate">Data de Expiração</label>
  </span>

  <div class="w-full" style="grid-column: 1 / -1">
    <h4>Regras de Exibição</h4>
    <div
      class="displayRules"
      formGroupName="displayRules"
      style="display: grid; grid-template-columns: repeat(5, 1fr); gap: 10px"
    >
      <div class="rule-group">
        <label>Assinante já comprou</label>
        <p-dropdown
          formControlName="subscriberBuyer"
          [options]="displayRuleOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione"
          appendTo="body"
        ></p-dropdown>
      </div>
      <div class="rule-group">
        <label>Não assinante</label>
        <p-dropdown
          formControlName="notSubscriber"
          [options]="displayRuleOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione"
          appendTo="body"
        ></p-dropdown>
      </div>
      <div class="rule-group">
        <label>Assinante nunca comprou</label>
        <p-dropdown
          formControlName="subscriberNotBuyer"
          [options]="displayRuleOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione"
          appendTo="body"
        ></p-dropdown>
      </div>
      <div class="rule-group">
        <label>Assinante top badge</label>
        <p-dropdown
          formControlName="topBadgeSubscriber"
          [options]="displayRuleOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione"
          appendTo="body"
        ></p-dropdown>
      </div>
    </div>
  </div>

  <p-card
    subheader="Preview dos produtos"
    *ngIf="products?.length"
    class="two-columns"
  >
    <p-carousel
      [value]="products"
      [numVisible]="6"
      [numScroll]="6"
      [circular]="false"
      [responsiveOptions]="responsiveOptionsSmall"
      [showNavigators]="products.length > 6"
      [showIndicators]="products.length > 6"
      class="carousel__glam"
    >
      <ng-template let-product pTemplate="item">
        <div class="collections-banner">
          <img
            *ngIf="product.images?.length"
            [alt]="product.name"
            [style.opacity]="product.stock?.quantity < 1 ? 0.2 : 1"
            [src]="product.images[0]"
            class="collection-banner"
          />
          <img
            *ngIf="!product.images?.length"
            [alt]="product.name"
            src="assets/images/no_img_available.jpg"
            class="collection-banner"
          />
          <span style="margin-top: 0.75rem; font-weight: 600">{{
            product.brand
          }}</span>
          <span style="margin-top: 0.25rem">{{ product.name }}</span>
          <p-badge
            [value]="'Sem estoque'"
            severity="danger"
            *ngIf="product.stock?.quantity < 1"
          />
          <p-badge
            [value]="'Em estoque'"
            severity="success"
            *ngIf="product.stock?.quantity > 0"
          />
        </div>
      </ng-template>
    </p-carousel>
  </p-card>

  <span class="buttons two-columns">
    <p-button
      label="Voltar"
      severity="danger"
      routerLink="/configuracoes/glam/new-home"
    />
    <p-button label="Salvar" type="submit" [disabled]="!form.valid" />
  </span>
</form>
